
import React, { Component } from "react";
import {  Link } from "react-router-dom"
import CliTerrainLocationSVPriceListView from '../../cliterrain/CliTerrainLocationSVPriceListView'
   
import {SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_NOTCAROUSEL_VIEW} from '../../../constants'

import InfiniteScroll from "react-infinite-scroll-component";
import moment from 'moment'
import SJCarousel from "../../../views/SJCarousel";
import SJCarouselDyna from "../../../views/SJCarouselDyna";
const style = {
  height: 30,
  border: "1px solid green",
  margin: 6,
  padding: 8
};


class CliSJScroll extends Component {

    state = {
        items: Array.from({ length: 5 }),
        hasMore: true
      };
     
     


      getCarouselOrPhoto = (o) =>{
         let ar =  o['imgs']
        let roomImgs =ar
        let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
        if(roomImgs && (roomImgs.length > 0)) {
             roomImg = roomImgs[0]
        }

        let photoOnly =  SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW :false
        
        if(photoOnly){
                      return  (
                  <div className="gallery">
                      <figure style={{'marginBottom':'0px'}}>
                      <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                      
                      <img src={`${roomImg}`}  alt="Carpet Grass" />
                      </Link> </span>
                          
                      </figure>
                  </div>)

        }
        //check ar
        if(ar && (ar.length > 2) ){
            let roomImgs = ar.slice(0,6)
          return ( <SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

        }else{
            return ( <SJCarousel ></SJCarousel>)
        }

    }
    
      //render start

      fetchMoreData = () => {
       
        const{svcli_esquery_data,my_scr_id} = this.props
       
        const {esqueryChilds,esqueryInfants,esqueryAdults,esquerySpecials,esqueryTripType,escountryOrg,esqueryShip,esqueryBrand,my_esqueryText,STARTDATE,ENDDATE,time_zone,esqueryPortcall,esqueryDur,esquerySailto,svpageSize} =svcli_esquery_data
        let esquerySailfrom = escountryOrg
        let startDate = STARTDATE
        let endDate = ENDDATE
        
       
        let start_date_s   = moment(startDate).toISOString() 
   

    let esqueryText = my_esqueryText ? my_esqueryText :'MCO' 
    let moEndDate = moment(endDate)
    let moStartDate = moment(startDate)
    let mo_es = moEndDate.format('YYYY-MM-DD') 
    let mo_ss = moStartDate.format('YYYY-MM-DD') 
    let end_date_s   = moment(endDate).toISOString() 
  
 if(!my_scr_id){
   console.log('FRAVE ERROR REDUCE SHOULD SUPPY my_scr_id ')
 }
 let sojPostRq= {
  "svfields": [
      "images",
      "sojourn_name",
      "address",
     
      "code",
      "sojournGeocode",
      "categoryCode",
      "categoryGroupCode",
      "accommodationTypeCode",

      "sojourn_city",
      "countryCode",
      "stateCode",
      "postalCode",
       "countryCode",
       "ranking",
       "web",
       "terminals",
      "destinationCode"
  ],
  "dates": {
      "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2025-10-24" ),
      "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2025-10-27" ),
      "DT_FORMAT": "%Y-%m-%d",
      "time_zone": "Asia/Kolkata",
      "OP": "range"
  },
  "facets": {
      "accommodationTypeCode": "H"
  },
 
  "esqueryChilds": "m0",
  "esqueryInfants": "i0",
  "esqueryAdults": "t1",
  "esquerySpecials": "J",
  
  "esqueryTripType": "roundtrip",
  "svpageSize": 5,
  "codeKeys": [
         
      ],
      /* during cruise the intermediataey strope where passenger wants to emabark and disemabrk immeigration check to see the city */
  "esqueryTripType": "roundtrip",

  "esqueryPortcall":esqueryPortcall ? esqueryPortcall : "PALL",
  "esqueryShip":"AQ",
  "esquerySpecials":"J",
  "esqueryDur":"D1",
 
  "esqueryBrand":"CARN",
  
  
  "org":esquerySailfrom ? esquerySailfrom : "LAX",
  "dst": esquerySailto ? esquerySailto : "A"
 
}


    let sojPostPaginateRqMore= {
    "svfields": [
        "images",
        "sojourn_name",
        "address",
        "code",
        "sojournGeocode",
        "categoryCode",
        "categoryGroupCode",
        "accommodationTypeCode",
        "sojourn_city",
        "countryCode",
        "stateCode",
        "postalCode",
        "countryCode",
        "ranking",
        "web",
        "terminals",
        "destinationCode"
    ],
    "dates": {
        "STARTDATE_ITN_TZAWARE_EST": "2026-04-01",
        "ENDDATE_ITN_TZAWARE_EST": "2026-04-30",
        "DT_FORMAT": "%Y-%m-%d",
        "time_zone": "Asia/Kolkata",
        "OP": "range"
    },
    "facets": {
        "accommodationTypeCode": "H"
    },
    "esqueryChilds": "m1",
    "esqueryInfants": "i0",
    "esqueryAdults": "t1",
    "esquerySpecials": "J",
    "esqueryTripType": "roundtrip",
    "svpageSize": 5,
    "codeKeys": [],
    "esqueryPortcall": "LAX",
    "esqueryShip": [
        "AQ"
    ],
    "esqueryDur": [
        "D1"
    ],
    "esqueryBrand": [
        "CARN"
    ],
    "org": "LAX",
    "dst": [
        "Mobile",
        "Puerto Plata",
        "St. Thomas",
        "Tortola",
        "Great Stirrup Cay",
        "Cozumel",
        "Roatan (Bay Islands)",
        "Harvest Caye",
        "Costa Maya"
    ],
    "my_scr_id": my_scr_id ? my_scr_id : ''
}
     
    sojPostRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
    sojPostRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
    sojPostRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")

    
    sojPostRq['esqueryTripType'] = (esqueryTripType ? esqueryTripType : "roundtrip")

    sojPostRq['esqueryPortcall'] = (esquerySailfrom ? esquerySailfrom : "LAX")
    sojPostRq['esqueryShip'] = (esqueryShip ? esqueryShip : ["AQ"])
    sojPostRq['esquerySpecials'] = (esquerySpecials ? esquerySpecials : "J")
    sojPostRq['esqueryDur'] = (esqueryDur ? esqueryDur : ["D1"])
    sojPostRq['esqueryBrand'] = (esqueryBrand ? esqueryBrand : ["CARN"])
   
      

        if (this.state.items.length >= 500) {
          this.setState({ hasMore: false });
          return;
        }
        // a fake async api call like which sends
        // 20 more records in .5 secs
        /*
          */
        this.props.cliAndImagesSojournMore(sojPostPaginateRqMore, svcli_esquery_data)
     
        /*
        setTimeout(() => {
          this.setState({
            items: this.state.items.concat(Array.from({ length: 5 }))
          });
        }, 500);
        */
      };
  render() {
    /*svjuly17 start */
    const {hasMore,my_data, sjSHIPofferselectparent, sjcruiseselectparent, sjfarselectparent, sjprobatecourtselectparent} = this.props
    let {ctotal} = this.props
    ctotal = ctotal ? ctotal :2
   
    let ndata = my_data ? my_data.length : -1
   

           
    return (
      <div className="main-listhotels">
         
        <InfiniteScroll
          dataLength={ctotal}
          next={this.fetchMoreData}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          endMessage={
            <div style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </div>
          }
        >
        
        
            <article className="main-listcruises">
                           
                            <div className="svr-clislist-container">
                                <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">

                                    <div className="svr-clilist-boxr-1">
                                        <div className="gallery">
                                            <figure style={{ width: '360px', height: '200px' }}>
                                                <span>	<Link to={`/svredsojourn`} >

                                                    <img style={{ width: '320px' }} src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                                </Link> </span>

                                            </figure>
                                        </div>
                                        <div className="svr-clilist-boxr-1">

                                            <p>
                                                <text className="svr-ex-ship">Norwegian bliss </text>
                                                <text className="svr-ex-name">4-Day Bahamas Round-Trip Miami: Great Stirrup Cay & Nassau </text>
                                                <text className="ter-l2 svr-ex-location">O Miami rlando</text>

                                            </p>


                                        </div>
                                        <div className="svr-clilist-boxr-1">

                                            <p>
                                                <text className="svr-ex-old-price">$558 </text>
                                                <text className="svr-ex-price">$329 </text>
                                                <text className="svr-ex-taxes">includes, taxes and fewa</text>

                                            </p>


                                        </div>
                                        <div className="svr-clilist-boxr-1">

                                            <p>
                                                <text className="svr-ex-itn">See Iineraryr </text>

                                            </p>


                                        </div>



                                    </div>


                                </div>
                                { 
                                 my_data.map(o => {
                                    
                                    let svcustProfile = {
                                        "customerId": -6,
                                        "addressId":-1
                                    }
                                    return (
                                        <div className="svr-clislist-box-row1 svr-sojlist-box-row1-last ">
                                            <div className="svr-clilist-boxr-1">
                                            {this.getCarouselOrPhoto(o)}
                                           
                                                <div className="svr-clilist-boxr-1">
                                                <CliTerrainLocationSVPriceListView excursionInfo={o} sjcruiseselectparent= {sjcruiseselectparent}    sjfarselectparent= {sjfarselectparent} svcustProfile={svcustProfile} sjSHIPofferselectparent={sjSHIPofferselectparent} ></CliTerrainLocationSVPriceListView>
                                                    
                        
                        
                                                </div>
                        
                        
                                            </div>
                                        </div>)
                                })
                                }
                            

                            </div>
            </article>
        </InfiniteScroll>
      </div>
    );
  }
      //render end

    
}

export default CliSJScroll;
